import * as UnitWeight from 'types/Accessory/Detail/UnitWeight';

export type Type = UnitWeight.Type[];

export function create(): Type {
	return [];
}

export function mapToApi(obj: Type): {
	[key: string]: number;
} {
	return obj.toDictionary(
		(u) => u.id,
		(w) => w.weight
	);
}
